import { EventExhibitorsFilters } from "@ac-expo/api-types";

export const eventsExhibitorsQueryKeys = {
  all: "events-exhibitors" as const,
  lists: () => [eventsExhibitorsQueryKeys.all, "lists"] as const,
  list: (eventId: string) =>
    [...eventsExhibitorsQueryKeys.lists(), eventId] as const,
  filteredList: (eventId: string, filters: EventExhibitorsFilters) =>
    [...eventsExhibitorsQueryKeys.list(eventId), filters] as const,
  details: () => [eventsExhibitorsQueryKeys.all, "details"] as const,
  detail: (eventId: string, exhibitorId: string) =>
    [...eventsExhibitorsQueryKeys.details(), eventId, exhibitorId] as const,
};
